import {
	type FetchWalletTransferOutCostParams,
	getProcessStartedAtDate,
	type WalletTransferOutRequestCostDTO
} from '@capsicum/common';
import { useMainCurrenciesQuery } from '@capsicum/socios-core';
import { useQuery } from '@tanstack/react-query';

import { fetchWalletTransferOutCost } from '../api';

/**
 * @params WalletTransferOutRequestCostDTO
 * @returns Estimate the cost in CHZ for a transfer out
 */
export const useWalletTransferOutCostQuery = <TData = undefined | WalletTransferOutRequestCostDTO>(
	params: FetchWalletTransferOutCostParams,
	select: (data: undefined | WalletTransferOutRequestCostDTO) => TData
) => {
	const { data: currencies, error: currenciesQueryError } = useMainCurrenciesQuery();

	if (currenciesQueryError) throw currenciesQueryError;

	const { convertAmountToCurrencies } = currencies ?? {};

	return useQuery({
		queryFn: () =>
			fetchWalletTransferOutCost({
				'convertAmountToCurrencies[]': convertAmountToCurrencies || [],
				processStartedAt: getProcessStartedAtDate(),
				...params
			}),
		queryKey: ['transferOutCost', params, convertAmountToCurrencies],
		select
	});
};
